import { Notyf } from "notyf";

export const toast: Notyf = new Notyf();
